<template>
  <div>
    <!-- 学校关注度最高的融合教学问题 -->
    <Echart
      :options="options"
      id="centerLeftChart"
      height="340px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        let colorList = [
          '#afa3f5',
          '#00d488',
          '#3feed4',
          '#3bafff',
          '#f1bb4c',
          'rgba(250,250,250,0.5)'
        ];
        this.options = {
          grid: {
            bottom: 150,
            left: 0,
            right: '10%'
          },
          legend: {
            show: false
          },
          series: [
            // 主要展示层的
            {
              radius: ['35%', '51%'],
              center: ['50%', '50%'],
              type: 'pie',
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorList[params.dataIndex];
                  }
                }
              },
              labelLine: {
                normal: {
                  show: true,
                  length: 15,
                  length2: 120,
                  lineStyle: {
                    color: '#d3d3d3'
                  },
                  align: 'right'
                },
                color: '#000',
                emphasis: {
                  show: true
                }
              },
              label: {
                normal: {
                  formatter: function (params) {
                    var str =
                      '{a|}\n{nameStyle|' +
                      params.name +
                      ' }' +
                      '{rate|' +
                      params.value +
                      '%}';
                    return str;
                  },
                  padding: [0, -110],
                  height: 165,
                  rich: {
                    a: {
                      width: 38,
                      height: 38,
                      lineHeight: 50,
                      align: 'left'
                    },
                    b: {
                      width: 29,
                      height: 45,
                      lineHeight: 50,
                      align: 'left'
                    },
                    c: {
                      width: 34,
                      height: 33,
                      lineHeight: 50,
                      align: 'left'
                    },
                    d: {
                      width: 34,
                      height: 44,
                      lineHeight: 50,
                      align: 'left'
                    },
                    e: {
                      width: 38,
                      height: 30,
                      lineHeight: 50,
                      align: 'left'
                    },
                    nameStyle: {
                      fontSize: 14,
                      color: '#ccc',
                      align: 'left'
                    },
                    rate: {
                      fontSize: 14,
                      color: '#ccc',
                      align: 'left'
                    }
                  }
                }
              },
              data: newData.data
            },
            // 边框的设置
            {
              radius: ['47%', '51%'],
              center: ['50%', '50%'],
              type: 'pie',
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              animation: false,
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: 'rgba(250,250,250,1)'
                }
              },
              data: [
                {
                  value: 1
                }
              ]
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
